import React from 'react';
import PropTypes from 'prop-types';
import { withHandlers } from '../../../../../../../node_module_clones/recompose';

import LinkButton from '../../../../../../components/buttons/LinkButton';

const buttonHandlers = withHandlers({
    handleTryAgainButtonClick:
        ({ searchForImages, searchQuery }) =>
        () =>
            searchForImages(searchQuery),
});

const SearchResultsError = ({ error, handleTryAgainButtonClick }) => (
    <div className="SearchResultsListEmpty SearchResultsListEmpty">
        <div className="error">{error}</div>
        <div className="try-again">
            <LinkButton onClickFn={handleTryAgainButtonClick} className="secondary">
                Try again
            </LinkButton>
        </div>
    </div>
);

SearchResultsError.propTypes = {
    error: PropTypes.string,
    handleTryAgainButtonClick: PropTypes.func,
};

export default buttonHandlers(SearchResultsError);
